import { useApolloClient } from '@apollo/client/react';
import { useModal } from "../../../../hooks/useModal"
import useDeleteMenu from '../../../../hooks/Menu/useDeleteMenu';
import useDeleteRestaurant from '../../../../hooks/Restaurant/useDeleteRestaurant';
import Button from "../../../ui/button/Button";
import { Modal } from "../../../ui/modal";
import { TrashBinIcon } from "../../../../icons"
import { useToast } from "../../../../context/ToastContext";
import useRestaurants from '../../../../hooks/Restaurant/useRestaurants';

type Props = {
  type: string
  id: number
}

const DeleteAction = ({ type, id }: Props) => {
  const client = useApolloClient();
  const { refetchRestaurants } = useRestaurants({
    fetchPolicy: "network-only",
    refetchOnMount: false,
  });
  const { isOpen: isOpenDelete, openModal: openModalDelete, closeModal: closeModalDelete } = useModal();
  const toast = useToast();
  const { deleteRestaurant } = useDeleteRestaurant({
    onCompleted: (restaurantDeleted) => {
      if (restaurantDeleted.id) {
        refetchRestaurants()
        closeModalDelete()
        return toast.success(`Restaurant ${restaurantDeleted.name} deleted successfully!`);
      }
    },
    onError: (err) => {
      if (err) return toast.error(String(err)); 
    }
  });
  const { deleteMenu } = useDeleteMenu({
    onCompleted: (menuDeleted) => {
      if (menuDeleted.id) {
        client.refetchQueries({
          include: [type], 
        });
        closeModalDelete()
        return toast.success(`Menu ${menuDeleted.name} deleted successfully!`);
      }
    },
    onError: (err) => {
      if (err) return toast.error(String(err)); 
    }
  });

  const deleteAction = async () => {
    switch (type) {
      case 'menus':
        return await deleteMenu({
          id: id!
        })
      case 'restaurants':
        return await deleteRestaurant({
          id: id!
        })
      default:
        return null;
    }
  }

  return (
    <>
      <button
        key={`delete-${type}-${id}`}
        onClick={openModalDelete}
        className="flex items-center justify-center gap-2 rounded-full border border-gray-300 bg-white px-4 py-3 text-sm font-medium text-gray-700 shadow-theme-xs hover:bg-gray-50 hover:text-gray-800 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.03] dark:hover:text-gray-200 lg:inline-flex lg:w-auto"
      >
        <TrashBinIcon width={20} height={20}/>
      </button>
      <Modal 
        isOpen={isOpenDelete}
        onClose={closeModalDelete}
        showCloseButton
        className="max-w-[700px] max-h-[95vh] overflow-x-auto custom-scrollbar">
          <>
            <p className="m-10 text-base text-center font-medium text-gray-800 dark:text-white/90">
              <span>You want to delete?</span>
            </p>
            <div className='mb-10 flex justify-evenly'>
              <Button 
                size="md" 
                variant="primary"
                onClick={deleteAction}
              >
                Yes
              </Button>
              <Button 
                size="md" 
                variant="outline"
                onClick={closeModalDelete}
              >
                Cancel
              </Button>
            </div>
          </>
      </Modal>
    </>
  );
}

export default DeleteAction;
